import { render, staticRenderFns } from "./SidebarNewPackage.vue?vue&type=template&id=9e9e4496"
import script from "./SidebarNewPackage.vue?vue&type=script&lang=js"
export * from "./SidebarNewPackage.vue?vue&type=script&lang=js"
import style0 from "./SidebarNewPackage.vue?vue&type=style&index=0&id=9e9e4496&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports